<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="申请人姓名" prop="nickname" >
        {{form.nickname}}
      </a-form-model-item>
      <a-form-model-item label="企业名称" prop="companyName" >
        {{form.companyName}}
      </a-form-model-item>
      <a-form-model-item label="当前岗位" prop="workName" >
        {{form.workName}}
      </a-form-model-item>
      <a-form-model-item label="入职日期 " prop="entryDate" >
        {{form.entryDate}}
      </a-form-model-item>
      <a-form-model-item label="员工单价 " prop="unitPrice" >
        {{form.unitPrice}}
      </a-form-model-item>
      <a-form-model-item label="薪资预支金额 " prop="money" >
        {{form.money}}
      </a-form-model-item>
      <a-form-model-item label="图片" prop="imgUrls" >
        <div v-if="form.imgUrls" style="display: flex;flex-wrap: wrap;width: 175px">
          <img
            v-if="item"
            v-viewer
            style="width: 80px;height: 80px;margin-right: 5px;margin-bottom: 5px"
            :src="item"
            :key="index"
            v-for="(item,index) in form.imgUrls.split(',')"/>
        </div>
        <div v-else>
          无反馈图片
        </div>
      </a-form-model-item>
      <a-form-model-item label="审核反馈图片" prop="checkImgs" >
        <a-upload
          :customRequest="fileUploadRequest"
          list-type="picture-card"
          :file-list="checkImgs"
          multiple
          @preview="handlePreview"
          @change="uploadImages">
          <div v-if="checkImgs.length < 9">
            <a-icon type="plus"/>
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
        <span style="color:#ff0000">支持.JPG格式 </span>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
          <img alt="example" style="width: 100%" :src="previewImage"/>
        </a-modal>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm(1)">
            通过
          </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm(2)" danger>
            拒绝
          </a-button>
          <a-button type="dashed" @click="cancel">
            关闭
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSalaryAdvance, addSalaryAdvance, updateSalaryAdvance } from '@/api/user/salaryAdvance'
import UploadFileToOSS from '@/utils/upload-file-to-oss'

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      checkImgs: [],
      // 表单参数
      form: {
        id: null,
        nickname: null,
        companyName: null,
        workName: null,
        entryDate: null,
        userId: null,
        money: null,
        imgUrls: '',
        unitPrice: null,
        status: 0,
        checkImgs: null,
        cateName: null,
        createTime: null,
        remark: null

      },
      // 1增加,2修改
      formType: 1,
      previewImage: null,
      previewVisible: false,
      open: false,
      rules: {
        cateName: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    handleCancel() {
      this.previewVisible = false
    },
    // 上传图片
    uploadImages({fileList}) {
      this.form.checkImgs = fileList
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    fileUploadRequest(fileInfo) {
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url
          fileInfo.file.ossUrl = ossUrl
          fileInfo.file.ossName = ossUrl
          fileInfo.onSuccess()
        }
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        nickname: null,
        companyName: null,
        workName: null,
        entryDate: null,
        userId: null,
        money: null,
        imgUrls: '',
        unitPrice: null,
        status: 0,
        checkImgs: null,
        cateName: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSalaryAdvance({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '审核'
      })
    },
    /** 提交按钮 */
    submitForm(status) {
      this.form.status = status
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSalaryAdvance(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSalaryAdvance(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
